import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

type Props = {
  title: string
}

const Title = ({ title }: Props) => {
  return (
    <Box
      mb={1}
      p={2}
      sx={{
        background: '#eee',
      }}
    >
      <Typography variant="h6">{title}</Typography>
    </Box>
  )
}

export default Title
